module.exports = __webpack_public_path__ + "4d9e7760ccc9fcaa10ccc1bb7162f833.png";